<template>
  <portal to="ModalRecommendation">
    <div class="modal-backdrop overflow-auto py-5">
      <div class="card mt-5">
        <div class="d-flex justify-content-end">
          <a>
            <img
              src="@/assets/icon/close.png"
              alt="close"
              @click="$emit('close', 'delete')"
            >
          </a>
        </div>
        <div
          v-if="isLoadingGet"
          class="card-body text-center text-info"
        >
          <div class="spinner-border spinner-border-sm">
            <span class="sr-only">
              Loading...
            </span>
          </div>
        </div>
        <div
          v-else
          class="card-body py-5 text-center"
        >
          <h5>
            {{ $t('manage-question.delete-text', { name: name }) }}
          </h5>
        </div>
        <div class="d-flex justify-content-center pt-3 pb-4">
          <button
            class="col-4 col-sm-3 btn btn-outline-info mx-2"
            @click="$emit('close', 'delete')"
          >
            {{ $t('manage-question.cancel') }}
          </button>
          <button
            v-if="!isLoadingDelete"
            class="col-4 col-sm-3 btn btn-info mx-2"
            @click="deleteQuestion"
          >
            {{ $t('manage-question.delete') }}
          </button>
          <button
            v-else
            class="col-4 col-sm-3 btn btn-info mx-2 text-center"
          >
            <div class="spinner-border spinner-border-sm">
              <span class="sr-only">
                Loading...
              </span>
            </div>
          </button>
        </div>
      </div>
    </div>

    <modal-unsuccessful
      v-show="modal.unsuccessful"
      :text-modal="modal.textModal"
      @closeModal="closeModal"
    />
    <modal-success
      v-show="modal.success"
      :text-modal="modal.textModal"
      @closeModal="closeModal"
    />
  </portal>
</template>

<script>
import Api from '@/utils/Api'
import ModalUnsuccessful from '@/components/modal/ModalUnsuccessful'
import ModalSuccess from '@/components/modal/ModalSuccess'

export default {
  components: {
    ModalUnsuccessful,
    ModalSuccess
  },

  props: {
    id: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    isLoadingGet: false,
    isLoadingDelete: false,
    name: '',
    modal: {
      textModal: '',
      success: false,
      unsuccessful: false
    }
  }),

  created () {
    this.initial()
  },

  methods: {
    async initial () {
      this.isLoadingGet = true
      const { data } = await Api.question.get(this.id)
      this.name = this.$i18n.locale === 'en' ? data.titleEng : data.titleIdn
      this.isLoadingGet = false
    },
    showModal (modalName) {
      this.modal[modalName] = true
    },
    closeModal (modalname) {
      this.modal[modalname] = false
      if (modalname === 'success') {
        this.$emit('close', 'delete')
      }
    },
    async deleteQuestion () {
      this.isLoadingDelete = true
      try {
        await Api.question.delete(this.id)
        this.modal.textModal = this.$t('manage-question.success-delete')
        this.showModal('success')
        this.isLoadingDelete = false
      } catch ({ response }) {
        this.modal.textModal = response.statusText
        this.showModal('unsuccessful')
        this.isLoadingDelete = false
      }
    }
  }
}
</script>

<style scoped>
.card {
  max-width: 600px;
  margin: 0 auto;
}
</style>
